import { render, staticRenderFns } from "./editAccredit.vue?vue&type=template&id=a8ead100&scoped=true"
import script from "./editAccredit.vue?vue&type=script&lang=js"
export * from "./editAccredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ead100",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8ead100')) {
      api.createRecord('a8ead100', component.options)
    } else {
      api.reload('a8ead100', component.options)
    }
    module.hot.accept("./editAccredit.vue?vue&type=template&id=a8ead100&scoped=true", function () {
      api.rerender('a8ead100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/editAccredit.vue"
export default component.exports